import {eventEmitter, lang} from "devSrc/common/baseData";
import langData2 from './lang.js'

export class EmailWidget {
    loadScript() {
      let getMessageText = langData2[lang];

        let script = document.createElement('div');
        script.id = 'pp-email-widget-73hgm78';
        script.className = 'ru_l';
        script.innerHTML = `<link rel="stylesheet" href="/email-widgets/widget/form-v6.css" media="all">
    <div class="email-widget-bubble"></div>
    <div class="pp-popup email-widget-popup">
        <div class="popup-wrap" id="pp-form">
            <a class="close-popup" href="#"></a>
            <div class="formcont-83yhb1">
                <div class="popup-title">
                    <span class="title-1">
                        <span>${getMessageText["title1"]} </span>
                        <span>${getMessageText["title1_2"]}</span>
                    </span>
                    <span class="title-2">${getMessageText["title2"]}</span>
                    <span class="title-main">${getMessageText["title-h1"]}</span>
                    <span class="title-3">${getMessageText["title3"]}</span>
                    <a class="join-tg-btn" href="https://t.ly/2mCM5" target="_blank">
                        <span class="tg-ico"></span>
                        <span>${getMessageText["join"]}</span>
                    </a>
                    <div class="promo_details">${getMessageText["discountDetail"]}
                        <div class="promo_details_txt">${getMessageText["discountDescr1"]} ${getMessageText["discountDescr2"]}</div>
                    </div>
                </div>
            </div>

        </div>
    </div>
`;

        let script2 = document.createElement('script');
        script2.type ='text/javascript';
        script2.async = true;
        script2.src = lang === "ru" ? '/email-widgets/widget/script_ru.js' : '/email-widgets/widget/script.js';

        document.body.append(script, script2);

            }
}

export default EmailWidget